import { useIntl } from "react-intl";
import { useSearchParams } from "react-router-dom";

import Dialog from "components/organisms/Dialog/Dialog";
import ImportDetailsInfo from "./ImportDetailsInfo";
import ValidationHistoryTable from "./ValidationHistoryTable";

export default function ImportDetailsDialog() {
  const intl = useIntl();
  const [searchParams, setSearchParams] = useSearchParams();
  const currentImportId = searchParams.get("import");

  return (
    <Dialog
      className="import-details-dialog"
      title={intl.formatMessage({
        id: "settings.fileImportTools.fileImportHistory.importDetails",
        defaultMessage: "Import Details",
      })}
      show={!!currentImportId}
      onHide={() => {
        searchParams.delete("import");
        setSearchParams(searchParams);
      }}
    >
      <ImportDetailsInfo />
      <ValidationHistoryTable />
    </Dialog>
  );
}
